module.exports = __webpack_public_path__ + "static/img/wdzt1-8.99e86c3.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/word/wdzt1-8.png
// module id = 857
// module chunks = 0